import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Highlight } from 'react-instantsearch-dom'

import { ContentTypes } from '@mc/track-event'
import { isLoggedIn } from '@mc/user-info'

import { trackClick } from '../events'
import { getSearchIndex } from '../getSearchIndex'

const fireTrackClick = (
  query,
  index,
  courseId,
  chapterId,
  courseSlug,
  pageSource,
) => {
  trackClick({
    query,
    index,
    content_type: ContentTypes.COURSE_CHAPTER,
    content_id: `${courseId}_${chapterId}`,
    slug: courseSlug,
    ...(pageSource && { page_source: pageSource }),
  })
}

export class Lesson extends Component {
  static propTypes = {
    query: PropTypes.string,
    courseId: PropTypes.number,
    chapterId: PropTypes.string,
    lesson: PropTypes.object,
    courseSlug: PropTypes.string,
    highlightAttribute: PropTypes.string,
    pageSource: PropTypes.string,
  }

  searchRef = React.createRef()

  generateUrl = (courseSlug, lesson) =>
    isLoggedIn()
      ? `/classes/${courseSlug}${
          lesson.chapter_url ?? `/chapters/${lesson.slug}`
        }`
      : `/classes/${courseSlug}`

  render() {
    const {
      lesson,
      courseSlug,
      query,
      courseId,
      chapterId,
      highlightAttribute = 'lesson_title',
      pageSource,
    } = this.props
    // search results v2 uses lesson.number_within_parent
    // however, we have decided not to show lesson number for v2
    const num = lesson.number

    return (
      <a
        data-role='search-hit'
        ref={this.searchRef}
        href={this.generateUrl(courseSlug, lesson)}
        className='d-flex mc-pl-5 mc-px-6 mc-py-4'
        onClick={() =>
          fireTrackClick(
            query,
            getSearchIndex(this.searchRef.current),
            courseId,
            chapterId,
            courseSlug,
            pageSource,
          )
        }
      >
        {typeof num === 'number' && (
          <span className='mc-text-small'>{num < 10 ? `0${num}` : num}.</span>
        )}
        <span className='mc-ml-2 mc-text-small'>
          <Highlight attribute={highlightAttribute} hit={lesson} />
        </span>
      </a>
    )
  }
}
